
import React, { SyntheticEvent, useState } from "react";
import { Button, Slider } from "@mui/material";
import { 
  ProjectAnimation,
  ProjectState, 
  updateProjectAnimation,
} from "../../../../shared";

type Props = {
  project: ProjectState
}

type AnimationButtonProps = { 
  animation?: ProjectAnimation,
  onClick: (animation?: ProjectAnimation) => void,
  selection?: ProjectAnimation,
}

function AnimationButton({ 
  animation, 
  selection,
  onClick 
}: AnimationButtonProps) {
  return (
    <Button 
      style={{
        margin: 4,
        backgroundColor: animation === selection ? 'blue' : 'white',
        color: animation === selection ? 'white' : 'blue',
      }}
      onClick={() => {
        onClick(animation);
      }}>
      {animation || 'none'}
    </Button>
  )
}

function AnimationControl({ project }: Props) {
  const [value, setValue] = useState(
    project.animation
  );

  const onClick = (animation?: ProjectAnimation) => {
    setValue(animation);
    updateProjectAnimation(project, animation);
  }

  return (
    <div style={{
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
    }}>
        Animation
        <div>
          <AnimationButton 
            selection={value}
            onClick={onClick} />
          <AnimationButton
            animation="zoomIn"
            selection={value}
            onClick={onClick} />
          <AnimationButton
            animation="zoomOut"
            selection={value}
            onClick={onClick} />
          <AnimationButton
            animation="panDown"
            selection={value}
            onClick={onClick} />
          <AnimationButton
            animation="panUp"
            selection={value}
            onClick={onClick} />
          <AnimationButton
            animation="panLeft"
            selection={value}
            onClick={onClick} />
          <AnimationButton
            animation="panRight"
            selection={value}
            onClick={onClick} />
        </div>
    </div>
  );
}

export default AnimationControl;